import { useEffect, useRef } from 'react';
import { useAuth } from '../../auth/contexts/AuthContext';
import { websocketService, type MessageHandler, type MessageNotification } from '../../../services/websocketService';

export function useWebSocket(onMessageReceived?: MessageHandler) {
  console.log('📡 useWebSocket hook called');
  const { user, keycloak, isAuthenticated, tokenVersion } = useAuth();
  const messageHandlerRef = useRef<MessageHandler | undefined>(onMessageReceived);
  
  // Update the ref when the handler changes
  useEffect(() => {
    messageHandlerRef.current = onMessageReceived;
  }, [onMessageReceived]);

  useEffect(() => {
    if (!isAuthenticated || !user || !keycloak?.token) {
      console.log('❌ WebSocket conditions not met:', { isAuthenticated, hasUser: !!user, hasToken: !!keycloak?.token });
      websocketService.disconnect();
      return;
    }

    console.log('🔗 Connecting WebSocket for user:', user.id);
    // Connect to WebSocket
    websocketService.connect(user.id, keycloak.token);

    // Add message handler if provided
    const handler: MessageHandler = (notification: MessageNotification) => {
      messageHandlerRef.current?.(notification);
    };

    if (messageHandlerRef.current) {
      websocketService.addMessageHandler(handler);
    }

    return () => {
      if (messageHandlerRef.current) {
        websocketService.removeMessageHandler(handler);
      }
    };
  }, [isAuthenticated, user, keycloak?.token, tokenVersion]);

  return {
    connectionStatus: websocketService.getConnectionStatus(),
    disconnect: () => websocketService.disconnect()
  };
}